export const getProfile = `query {
  getProfile {
    id
    first_name
    last_name
    email
    api_token
    phone_number
    avatar
    is_enable_notif
    is_enabled_2fa
    roles
    organisations {
      id
      avatar
      title
      website
      country
      address
      num_employees
      industry { id title }
      quota
      consumed_quota
      subscription {
        end_date
        plan {
          name
          color
          services {
            id
            service
            slug
          }
        }
      }
    }
  }
}`;